<template>
    <div>
        <div class="row" >
            <div class="col-md-3 col-sm-12 offset-md-9" style="display:flex;flex-direction:row-reverse;">
                <button class="btn btn-outline-success w-50 p-5" v-on:click="addUser()"><i class="fas fa-user-plus"></i> Add User</button>
            </div>
        </div>
        <div class="table-div">
            <table class="table mt-4" v-if="listOfUser">
                <thead>
                    <th class="headTitle" v-for="header in tableHeaders" @click="selectSort(header.value)">{{ header.name }}</th>
                    <th>User Option</th>
                </thead>
                <tbody v-for="user in listOfUser">
                    <tr>
                        <td>{{user.user_id}}</td>
                        <td>{{user.username}}</td>
                        <td>{{user.name}}</td>
                        <td>{{user.type}}</td>
                        <td>{{user.last_login}}</td>
                        <td>{{user.status}}</td>
                        <td>{{user.created_at}}</td>
                        <td class='text-center'>
                            <button class="editbtn btn btn-primary mr-2" v-on:click="editUser(user.user_id)" title="Edit User"><i class="fas fa-edit"></i></button>
                            <button class="deletebtn btn btn-danger mr-2" v-on:click='deleteUser(user.user_id)' title="Delete User"><i class="fas fa-user-minus"></i></button>
                        </td>
                    </tr>
                </tbody>

            </table>
        </div>
        <hr>
        <p v-if="meta">Showing {{1 + ((meta.currentPage - 1) * 10)}} to {{meta.currentPage != meta.lastPage ? meta.currentPage * 10 : meta.total}} of {{meta.total}} entries.</p>
        <div class="row">
            <div class="col" style="padding: 20px">
                <nav>
                    <ul class="pagination" style="justify-content:center">
                        <li class="page-item" :class="{'disabled' : (config.currentPage <= 1)}" @click="laquo()">
                            <span class="page-link">&laquo;</span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage <= 1)}" @click="lsaquo()">
                            <span class="page-link">&lsaquo;</span>
                        </li>
                        <li class="page-item pageNumber" style="cursor:pointer">
                            <span class="page-link" style="color:black">
                                <span style="font-weight: bold !important">{{(config.maxPage < 1) ? 0 : config.currentPage}}</span> of {{config.maxPage}}
                            </span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage >= config.maxPage)}" @click="rsaquo()">
                            <span class="page-link">&rsaquo;</span>
                        </li>
                        <li class="page-item" :class="{'disabled' : (config.currentPage >= config.maxPage)}" @click="raquo()">
                            <span class="page-link">&raquo;</span>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data(){
        return {
            listOfUser : null,
            config : {
                currentPage : 1,
                maxPage : 1,
                limitPerPage : 15,//LIMIT PER PAGE
                by : "user_id",
                order : false,//true = ascending, false = descending, for start, Reverted
            },
            tableHeaders : [],
            tableHeaderTitles : [],
            meta : null
        }
    },
    props:["managementType" , 'name'],
    mounted(){
        this.addTableHeader('user_id', 'User ID')
        this.addTableHeader('username', 'Username')
        this.addTableHeader('name', 'Name')
        this.addTableHeader('type', 'Type')
        this.addTableHeader('last_login', 'Last Login')
        this.addTableHeader('status', 'Status')
        this.addTableHeader('created_at', 'Created At')

        this.selectSort(this.config.by);
    },
    watch:{
        "managementType" : function(){
            this.selectSort(this.config.by);
        },
        "name" : function() {
            this.selectSort(this.config.by);
        }
    },
    methods : {
        deleteUser(id){
            this.$swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
            if (result.value) {
                var url = "/api/users/"+ id + "?access=" + this.managementType;
                this.$http.delete(url)
                .then((resp)=>{
                    this.$swal.fire(
                    'Deleted!',
                    'The requested user is deleted.',
                    'success'
                    ).then((result)=>{
                        this.fetchData(1);
                    })
                })
                .catch((err)=>{
                    
                    console.log(err);
                })
                
            }
            })
        },
        editUser(user_id){
            this.$router.push({name : 'EditUser' , params : { id : user_id , access : this.managementType}});
        },
        laquo(){//first page
            if(this.config.currentPage-1 > 0){
                this.fetchData(1);
            } else {
                this.errorPrint("First Page Reached!");
            }
        },
        lsaquo(){//previous page
            if(this.config.currentPage-1 > 0){
                this.fetchData(this.config.currentPage-1);
            } else {
                this.errorPrint("Last Page Reached!");
            }
        },
        rsaquo(){//next page
            if(this.config.currentPage+1 <= this.config.maxPage){
                this.fetchData(this.config.currentPage+1);
            } else {
                this.errorPrint("Last Page Reached!");
            }
        },
        raquo(){//last page
            if(this.config.currentPage+1 <= this.config.maxPage){
                this.fetchData(this.config.maxPage);
            } else {
                this.errorPrint("Last Page Reached!");
            }
        },
        selectSort(sortVariable){
            if(sortVariable == null){
                alert('Feature Unavailable');
                return;
            }
            if(this.config.by != sortVariable){
                this.config.by = sortVariable
                this.config.order = false
                this.fetchData(1)
            } else {
                this.config.order = !this.config.order
                if(this.config.order)
                    this.fetchData(1)
                else
                    this.fetchData(1)
            }
            this.changeSortTitle();
        },
        changeSortTitle(){
            for(var i = 0; i < this.tableHeaders.length; i++){
                if(this.config.by == this.tableHeaders[i].value){
                    if(this.config.order)
                        this.tableHeaders[i].name = this.tableHeaderTitles[i] + '▲'
                    else
                        this.tableHeaders[i].name = this.tableHeaderTitles[i] + '▼'
                } else {
                    this.tableHeaders[i].name = this.tableHeaderTitles[i]
                }
            }
        },
        addTableHeader(variable, title){
            let header = {
                value : variable,
                name : title
            }
            this.tableHeaders.push(header);
            this.tableHeaderTitles.push(title);
        },
        fetchData(page){//PAGE(1,2,3,4)
            // var url = `/api/log/list/${this.rq_uuid}?limit=${this.config.limitPerPage}`;
            

            var url = "/api/users?access=" + this.managementType;
            if(this.name != '')
                url += '&name=' + this.name

            url = `${url}&limit=${this.config.limitPerPage}&order=${(this.config.order)?'ASC':'DESC'}&by=${this.config.by}`//ADDS LIMIT, ORDER, AND BY

            if(page)
                url = url + '&page=' + page;

            this.$http.get(url)
            .then((resp)=>{
                if(resp.data.code != 200)
                    throw new Error(resp.data.message)
         
                var data = resp.data.data;
                var meta = resp.data.meta;
                this.meta = meta;

                this.config.currentPage = meta.currentPage;
                this.config.maxPage = meta.lastPage;
                
                this.listOfUser = data;

                var tzoffset = (new Date()).getTimezoneOffset() * 60000;

                for(var i = 0 ; i < this.listOfUser.length ; i++){
                    this.listOfUser[i].created_at = this.listOfUser[i].created_at ? new Date( new Date(this.listOfUser[i].created_at)- tzoffset ).toISOString().replace("T" , " ").slice(0,19) : null;
                    this.listOfUser[i].last_login = this.listOfUser[i].last_login ?new Date( new Date(this.listOfUser[i].last_login)- tzoffset ).toISOString().replace("T" , " ").slice(0,19) : null;
                }
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        addUser(){
            this.$router.push({name : "AddUser"});
        }
    }

}
</script>

<style scoped>
    th {
        text-align: center;
    }
    td{
        text-align: center;
    }
    .table-div{
        display: block;
        overflow: scroll;
    }

    /*pagination css*/
    .headTitle{
        cursor: pointer;
    }
    .page-link{
        cursor: pointer;
    }
    .pageNumber .page-link:hover{
        background-color: white;
        cursor: default;
    }
    .disabled .page-link{
        background-color:#EEEEEE;
    }
    li .disabled:hover{
        cursor: default;
    }
    .editbtn{
        transition: all ease-in-out 0.1s;
        cursor: pointer;
    }
    .editbtn:hover{
        background-color: #34d5eb;
    }

    .deletebtn{
        transition: all ease-in-out 0.1s;
        cursor: pointer;
    }
    .deletebtn:hover{
        background-color: #f75050;
    }
    /*pagination css ends*/
</style>